import copy from "copy-text-to-clipboard";
import localforage from "localforage";
import React from "react";
import { connect } from "react-redux";
import { popupList } from "../../../../constants/reader/popupList";
import Note from "../../../../model/Note";
import {
  handleChangeDirection,
  handleFetchNotes,
  handleMenuMode,
  handleOpenMenu,
  handleOriginalText,
} from "../../../../redux/actions/reader";
import { getHightlightCoords } from "../../../../utils/reader/fileUtils/pdfUtil";
import RecordLocation from "../../../../utils/reader/readUtils/recordLocation";
import {
  getIframeDoc,
  getIframeDoc2,
} from "../../../../utils/reader/serviceUtils/docUtil";
import {
  getSelection,
  getSelection2,
} from "../../../../utils/reader/serviceUtils/mouseEvent";
import StorageUtil from "../../../../utils/reader/serviceUtils/storageUtil";
import {
  getPollyVoices,
  getStoredVoiceId,
  resolveVoiceById,
  saveVoiceId,
  toPollyRate,
} from "../../../../utils/reader/textToSpeechUtil";
import {
  cancelPollyTts,
  isPollyTtsAuthorized,
  speakWithPolly,
  unlockPollyTts,
} from "../../../../utils/reader/pollyTts";
import { openExternalUrl } from "../../../../utils/reader/serviceUtils/urlUtil";
import ColorOption from "../../colorOption/component";
import "./popupOption.css";
import { Tooltip } from "react-tippy";
import { Trans } from "react-i18next";
import SelectOption from "../../../SelectOption/SelectOption";
import { STYLETYPE_SECOND } from "../../../../utils/Contants";
import { getElementById } from "domutils";

class PopupOption extends React.Component {
  constructor(props) {
    super(props);
    this.playSound = false;
    this.speakGeneration = 0;
    this.speakingText = "";
    this.state = {
      selectedVoiceId: getStoredVoiceId(),
    };
  }

  getSelectionText = () => {
    return (localStorage.getItem("selectionaa") || "").replace(
      /(\r\n|\n|\r)/gm,
      ""
    );
  };
  handleNote = () => {
    //console.log("handleNote");
    this.props.handleChangeDirection(false);
    this.props.handleMenuMode("note");
    this.handleEdge();
  };
  handleEdge = () => {
    //console.log("PopupOption2", this.props);
    //TO DO position
    let page = { offsetLeft: 0 };

    if (this.props.currentBook.format !== "PDF") {
      page = document.getElementById("page-area");
      if (!page.clientWidth) return;
    }
    let popupMenu = document.querySelector(".popup-menu-container");
    let posX = popupMenu?.style.left;
    let posY = popupMenu?.style.top;
    posX = parseInt(posX.substr(0, posX.length - 2));
    posY = parseInt(posY.substr(0, posY.length - 2));
    let rightEdge = this.props.pageWidth - 310 + page.offsetLeft * 2;
    if (this.props.leftOrRight == 1) {
      rightEdge = this.props.pageWidth + page.offsetLeft * 2;
    }
    if (posX > rightEdge) {
      popupMenu?.setAttribute("style", `left:${rightEdge}px;top:${posY}px`);
    }
  };
  handleCopy = () => {
    let text = "";
    if (this.props.currentBook.format === "EPUB") {
      text = getSelection2(this.props.leftOrRight);
    } else if (this.props.currentBook.format === "PDF") {
      text = getSelection2(0);
    }
    text = localStorage.getItem("selectionaa").replace(/(\r\n|\n|\r)/gm, "");
    if (!text) return;
    copy(text);
    this.props.handleOpenMenu(false);
    let doc = getIframeDoc2(this.props.leftOrRight);
    if (!doc) return;
    doc.getSelection()?.empty();
    alert("Copy Successfully");
  };
  handleTrans = () => {
    this.props.handleMenuMode("trans");
    if (this.props.currentBook.format != "PDF") {
      this.props.handleOriginalText(
        getSelection2(this.props.leftOrRight) || ""
      );
    } else {
      this.props.handleOriginalText(getSelection2(0) || "");
    }
    this.handleEdge();
  };
  handleDigest = () => {
    ////console.log("handleDigest left or right:",this.props.leftOrRight);
    // //console.log("handleDigest this.props:",this.props);
    // //console.log("handleDigest, localStorage range 111" + localStorage.getItem("range") );

    let _localStorage_range = {};
    try {
      _localStorage_range = JSON.parse(localStorage.getItem("range"));
    } catch (err) {
      //console.log("err", err);
    }
    // //console.log("handleDigest, localStorage range 222", _localStorage_range );

    let bookKey = this.props.currentBook.key;
    let cfi = "";
    if (this.props.currentBook.format === "EPUB") {
      cfi = RecordLocation.getCfi(this.props.currentBook.key).cfi;
    } else if (this.props.currentBook.format === "PDF") {
      cfi = JSON.stringify(
        RecordLocation.getPDFLocation(this.props.currentBook.md5)
      );
    } else {
      cfi = JSON.stringify(
        RecordLocation.getHtmlLocation(this.props.currentBook.key)
      );
    }
    let percentage = RecordLocation.getCfi(this.props.currentBook.key)
      .percentage
      ? RecordLocation.getCfi(this.props.currentBook.key).percentage
      : 0;
    let color = this.props.color;
    let notes = "";
    let pageArea = document.getElementById("page-area");
    if (!pageArea) return;
    //let iframe = pageArea.getElementsByTagName("iframe")[this.props.leftOrRight];
    let iframe;
    if (this.props.currentBook.format === "PDF") {
      iframe = pageArea.getElementsByTagName("iframe")[0];
    } else {
      iframe = pageArea.getElementsByTagName("iframe")[this.props.leftOrRight];
    }
    // if (!iframe) return;
    // let doc = iframe.contentDocument;
    // if (!doc) return;

    ////console.log("ddddddfeeee",doc.getSelection());
    // let charRange;
    // if (this.props.currentBook.format !== "PDF") {
    //   charRange = window.rangy
    //     .getSelection(iframe)
    //     .saveCharacterRanges(doc.body)[0];
    // }
    // //console.log("handleDigest charRange", charRange);
    // if (charRange == undefined) {
    //   charRange = _localStorage_range;
    // }

    let range =
      this.props.currentBook.format === "PDF"
        ? JSON.stringify(getHightlightCoords())
        : JSON.stringify(_localStorage_range);
    //let text = doc.getSelection()?.toString();
    let text = localStorage.getItem("selectionaa");
    //console.log("ssdsfsdfsdfsdfsdfdsfsdfs", text);
    if (!text) return;
    text = text.replace(/\s\s/g, "");
    text = text.replace(/\r/g, "");
    text = text.replace(/\n/g, "");
    text = text.replace(/\t/g, "");
    text = text.replace(/\f/g, "");
    // //console.log("bookKey:::::",bookKey)
    // //console.log("chapter:::::",this.props.chapter)
    // //console.log("chapterIndex:::::",this.props.chapterIndex)
    // //console.log("text:::::",text)
    // //console.log("cfi:::::",cfi)
    // //console.log("notes:::::",notes)
    // //console.log("percentage:::::",percentage)
    // //console.log("color:::::",color)
    // //console.log("this.props.leftOrRight:::::",this.props.leftOrRight)

    let digest = new Note(
      bookKey,
      this.props.chapter,
      this.props.chapterIndex,
      text,
      cfi,
      range,
      notes,
      percentage,
      color,
      this.props.leftOrRight,
      []
    );
    //console.log("digest", digest);
    let noteArr = this.props.notes;
    noteArr.push(digest);
    localforage.setItem("notes", noteArr).then(() => {
      this.props.handleOpenMenu(false);
      //alert("Add Successfully");
      this.props.handleFetchNotes();
      this.props.handleMenuMode("highlight");
    });

    // let classes = [
    //   "color-0",
    //   "color-1",
    //   "color-2",
    //   "color-3",
    //   "line-0",
    //   "line-1",
    //   "line-2",
    //   "line-3",
    // ];
    // if (this.props.currentBook.format === "PDF") {
    //   showHighlight(JSON.parse(range), classes[color]);
    // }
  };
  handleJump = (url) => {
    openExternalUrl(url);
  };
  handleSearchInternet = () => {
    let text = "";
    if (this.props.currentBook.format === "EPUB") {
      text = getSelection2(this.props.leftOrRight);
    } else if (this.props.currentBook.format === "PDF") {
      text = getSelection2(0);
    }

    text = localStorage.getItem("selectionaa").replace(/(\r\n|\n|\r)/gm, "");
    switch (StorageUtil.getReaderConfig("searchEngine")) {
      case "google":
        this.handleJump("https://www.google.com/search?q=" + text); //getSelection2(this.props.leftOrRight));
        break;
      case "baidu":
        this.handleJump("https://www.baidu.com/s?wd=" + text); //getSelection2(this.props.leftOrRight));
        break;
      case "bing":
        this.handleJump("https://www.bing.com/search?q=" + text); //getSelection2(this.props.leftOrRight));
        break;
      case "duckduckgo":
        this.handleJump("https://duckduckgo.com/?q=" + text); //getSelection2(this.props.leftOrRight));
        break;
      case "yandex":
        this.handleJump("https://yandex.com/search/?text=" + text); //getSelection2(this.props.leftOrRight));
        break;
      case "yahoo":
        this.handleJump("https://search.yahoo.com/search?p=" + text); //getSelection2(this.props.leftOrRight));
        break;
      case "naver":
        this.handleJump(
          "https://search.naver.com/search.naver?where=nexearch&sm=top_hty&fbm=1&ie=utf8&query=" +
            text //getSelection2(this.props.leftOrRight)
        );
        break;
      case "baike":
        this.handleJump("https://baike.baidu.com/item/" + text); //getSelection2(this.props.leftOrRight));
        break;
      case "wiki":
        this.handleJump("https://en.wikipedia.org/wiki/" + text); //getSelection2(this.props.leftOrRight));
        break;
      default:
        this.handleJump(
          navigator.language === "zh-CN"
            ? "https://www.baidu.com/s?wd=" + text //getSelection2(this.props.leftOrRight)
            : "https://www.google.com/search?q=" + text //getSelection2(this.props.leftOrRight)
        );
        break;
    }
  };
  handleSearchBook = () => {
    let leftPanel = document.querySelector(".left-panel");
    const clickEvent = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    // //console.log("handleSearchBook111111",this.props.currentBook.format )
    if (this.props.currentBook.format === "EPUB") {
      if (!leftPanel) return;
      leftPanel.dispatchEvent(clickEvent);
    }
    const focusEvent = new MouseEvent("focus", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    let searchBox;
    let searchIcon;
    if (this.props.currentBook.format === "PDF") {
      searchBox = document
        .getElementsByTagName("iframe")[0]
        .contentDocument.getElementById("findInput");
      searchIcon = document
        .getElementsByTagName("iframe")[0]
        .contentDocument.getElementById("viewFind");
      //console.log("searchBox", searchBox);
      //console.log("searchIcon", searchIcon);
    } else if (this.props.currentBook.format === "EPUB") {
      searchBox = document.querySelector(".header-search-box");
      searchIcon = document.querySelector(".header-search-icon");
      //console.log("searchBox2", searchBox);
      //console.log("searchIcon2", searchIcon);
    }
    searchBox.dispatchEvent(focusEvent);
    if (this.props.currentBook.format === "PDF") {
      if (!searchIcon.classList.contains("toggled")) {
        searchIcon?.dispatchEvent(clickEvent);
      }
    } else if (this.props.currentBook.format === "EPUB") {
      searchIcon?.dispatchEvent(clickEvent);
    }

    let text = "";
    if (this.props.currentBook.format === "EPUB") {
      text = getSelection2(this.props.leftOrRight);
    } else if (this.props.currentBook.format === "PDF") {
      text = getSelection2(0);
    }
    text = localStorage.getItem("selectionaa").replace(/(\r\n|\n|\r)/gm, "");
    //console.log("searchbox", text);
    searchBox.value = text; //getSelection2(this.props.leftOrRight) || "";
    const keyEvent = new KeyboardEvent("keydown", {
      bubbles: true,
      cancelable: true,
      keyCode: 13,
    });
    searchBox.dispatchEvent(keyEvent);
    this.props.handleOpenMenu(false);
  };

  handleSpeak = async () => {
    const text = this.getSelectionText();
    if (!text.trim()) {
      this.playSound = false;
      this.speakingText = "";
      return;
    }

    if (!isPollyTtsAuthorized()) {
      this.playSound = false;
      this.speakingText = "";
      alert("請先登入後再使用聽書");
      return;
    }

    const voice = resolveVoiceById(this.state.selectedVoiceId);
    if (!voice) {
      this.playSound = false;
      this.speakingText = "";
      return;
    }

    const generation = ++this.speakGeneration;
    unlockPollyTts();
    this.playSound = true;
    this.speakingText = text;

    try {
      await speakWithPolly({
        text,
        language: voice.language,
        rate: toPollyRate("1"),
        shouldContinue: () =>
          this.playSound && generation === this.speakGeneration,
      });
    } catch (error) {
      if (generation === this.speakGeneration) {
        console.error("TTS error", error);
      }
    } finally {
      if (generation === this.speakGeneration) {
        this.playSound = false;
        this.speakingText = "";
      }
    }
  };

  handleChange = (event) => {
    const voiceId = event.target.value;
    const voice = resolveVoiceById(voiceId);
    if (!voice) {
      return;
    }

    saveVoiceId(voice.id);
    this.setState({ selectedVoiceId: voice.id });
  };

  stopSpeaking = () => {
    this.speakGeneration += 1;
    this.playSound = false;
    this.speakingText = "";
    cancelPollyTts();
  };

  handleSpeakClick = () => {
    const text = this.getSelectionText();
    if (this.playSound && text === this.speakingText) {
      this.stopSpeaking();
      return;
    }
    this.handleSpeak();
  };

  render() {
    const renderMenuList = () => {
      return (
        <>
          <div className="menu-list">
            {popupList.map((item, index) => {
              return (
                <div
                  key={item.name}
                  className={item.name + "-option"}
                  onClick={() => {
                    switch (index) {
                      case 0:
                        this.handleNote();
                        break;
                      case 1:
                        this.handleDigest();
                        break;
                      case 2:
                        this.handleTrans();
                        break;
                      case 3:
                        this.handleCopy();
                        break;
                      case 4:
                        this.handleSearchBook();
                        break;
                      case 5:
                        this.handleSearchInternet();
                        break;
                      case 6:
                        this.handleSpeakClick();
                        break;

                      default:
                        break;
                    }
                  }}
                >
                  <Tooltip
                    title={item.title}
                    position="top"
                    trigger="mouseenter"
                    theme="light"
                  >
                    <span
                      className={`icon-${item.icon} ${item.name}-icon`}
                    ></span>
                  </Tooltip>
                  {
                    index === 6 ? (
                      <select
                        id="voiceIdx"
                        value={this.state.selectedVoiceId}
                        onChange={this.handleChange}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {getPollyVoices().map((voice) => (
                          <option key={voice.id} value={voice.id}>
                            {voice.label}
                          </option>
                        ))}
                      </select>
                    ) : null
                  }
                </div>
              );
            })}
          </div>
          <ColorOption {...{ readerType: this.props.readerType }} />
        </>
      );
    };
    return renderMenuList();
  }
}
const mapStateToProps = (state) => {
  return {
    currentBook: state.book.currentBook,
    currentEpub: state.book.currentEpub,
    selection: state.viewArea.selection,
    notes: state.reader.notes,
    color: state.reader.color,
    flattenChapters: state.reader.flattenChapters,
  };
};
const actionCreator = {
  handleOpenMenu,
  handleMenuMode,
  handleFetchNotes,
  handleOriginalText,
  handleChangeDirection,
};
export default connect(mapStateToProps, actionCreator)(PopupOption);
